"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_i18next_1 = require("react-i18next");
var Combos_1 = __importDefault(require("./Combos"));
var ShortcutsGroup_less_1 = __importDefault(require("./ShortcutsGroup.less"));
var ShortcutsGroup = function (_a) {
    var className = _a.className, label = _a.label, shortcuts = _a.shortcuts;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, ShortcutsGroup_less_1.default['shortcuts-group']) },
        react_1.default.createElement("div", { className: ShortcutsGroup_less_1.default['title'] }, t(label)),
        react_1.default.createElement("div", { className: ShortcutsGroup_less_1.default['shortcuts'] }, shortcuts.map(function (_a) {
            var name = _a.name, label = _a.label, combos = _a.combos;
            return (react_1.default.createElement("div", { className: ShortcutsGroup_less_1.default['shortcut'], key: name },
                react_1.default.createElement("div", { className: ShortcutsGroup_less_1.default['label'] }, t(label)),
                react_1.default.createElement(Combos_1.default, { combos: combos })));
        }))));
};
exports.default = ShortcutsGroup;
